<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">
                Healthcare
            </h2>
            <ul data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>Healthcare</li>
            </ul>
        </div>
    </div>
</div>


<section class="team-area ">
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <!-- <div class="col-lg-12 col-md-12 col-sm-12">
                   
                </div> -->
                <div class=" media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/12121implement.png" alt="image" />
                    </div>
                </div>

                <div class=" text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            User-friendly Interface
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Vocbot makes it easier for patients to book appointments, get consistent and accurate
                            responses, reminders, post-discharge follow-ups, etc. Vocbot can act as a virtual health
                            assistant.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class=" text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            24/7 Availability
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Offers round-the-clock availability, enabling customers to get support at any time during
                            emergency situations, enhancing customer satisfaction and service accessibility.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/health-feedback.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class=" media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/health-attan.png" alt="image" />
                    </div>
                </div>

                <div class=" text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Efficient Triage Process
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            With intelligent algorithms, Vocbot swiftly triages patient inquiries, directing urgent
                            cases to the concerned person while providing timely guidance for non-emergency concerns.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class=" text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Seamless Integration
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Seamlessly Integrating, with existing healthcare systems, vocbot streamlines processes such
                            as appointment scheduling, prescription refills, and medical record retrieval.
                        </p>
                    </div>
                </div>
                <div class=" media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/technology-for-better-healthcare.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class=" media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/health-confirm.png" alt="image" />
                    </div>
                </div>

                <div class=" text  col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Personalized Health Insights
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Leveraging patient data and AI-driven
                            analytics, Vocbot delivers personalized
                            health insights, empowering individuals to
                            proactively manage their well-being.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="  text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Continuous Learning and Improvement
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            With machine learning capabilities,
                            Vocbot continuously learns from
                            interactions, refining its responses and
                            recommendations to better serve patients
                            over time.
                        </p>
                    </div>
                </div>
                <div class=" media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/old-man-and-woman.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class=" media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/health-payment.png" alt="image" />
                    </div>
                </div>

                <div class=" text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Compliance and Security
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Adhering to stringent data privacy
                            regulations, Vocbot ensures
                            the confidentiality and security of patient
                            information, fostering trust and confidence
                            in the healthcare ecosystem.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="team-area ptb-110">
<div
    class="page-heading"
    data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1200"
    style="
        height: 150px;
        text-align: center;
        color: #000000;
        margin-bottom: 40px;
        text-transform: uppercase;
    "
>
    <h1>
        <b>Healthcare Problems: How Vocbot  Solves Them Simply</b>
    </h1>
    <img src="assets/img/RO.gif" style="height: 35px" />
</div>



<div class="row">
        <div class="container-fluid"  >

        <div class="row member-content">
            <div class="col-lg-12 col-md-12">

               
                <div class="row row-margin-1" data-aos="zoom-in">
                    <div class="col-sm-12 col-md-4  col-lg-4 member-thumb-1 ">
                        <img src="assets/img/30576711_7706584.jpg" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-8 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                        
                            <p class="title mb-2">User-friendly Interface</p>
                            
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">The  Vocbot  AI website boasts a user-friendly interface, simplifying navigation for patients seeking healthcare assistance.</p>
                        </div>
                    </div>
                </div>

           

    
                <div class="row row-margin-2 mobile-margin-top" data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">24/7 Availability</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Offering round-the-clock availability, the  Vocbot  ensures patients can access support and information at any time, enhancing convenience and accessibility.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2  order-sm-1 order-xs-1 order-1 ">
                        <img src="assets/img/health-feedback.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>


           
                <div class="row row-margin-1  mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1  ">
                        <img src="assets/img/health-attan.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8  mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Efficient Triage Process</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Through intelligent algorithms, the  Vocbot  swiftly triages patient inquiries, directing urgent cases to healthcare professionals while providing timely guidance for non-emergency concerns.</p>
                        </div>
                    </div>
                </div>

               

    
                <div class="row row-margin-2 mobile-margin-top" data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-lg-2  order-sm-2 order-xs-2 order-2 mobile-content ">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Seamless Integration</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Seamlessly integrating with existing healthcare systems, the  Vocbot  streamlines processes such as appointment scheduling, prescription refills, and medical record retrieval.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1 ">
                        <img src="assets/img/health-promo.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>


               
                <div class="row row-margin-1 mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1  ">
                        <img src="assets/img/health-confirm.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-lg-2  order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Personalized Health Insights</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Leveraging patient data and AI-driven analytics, the  Vocbot  delivers personalized health insights, empowering individuals to proactively manage their well-being.</p>
                        </div>
                    </div>
                </div>
 
        

    
                <div class="row row-margin-2 mobile-margin-top " data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Continuous Learning and Improvement</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">With machine learning capabilities, the  Vocbot  continuously learns from interactions, refining its responses and recommendations to better serve patients over time.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1 function-image  ">
                        <img  src="assets/img/health-call.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>

                <div class="row row-margin-1 mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1 order-lg-1 order-sm-1 order-xs-1 order-1  function-image">
                        <img src="assets/img/health-payment.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Compliance and Security</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Adhering to stringent data privacy regulations, the  Vocbot  AI website ensures the confidentiality and security of patient information, fostering trust and confidence in the healthcare ecosystem.</p>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    
    </div>
</div>
</section> -->